module.exports = __webpack_public_path__ + "img/香橼.e6ea4ce8.jpg";